import {
  IdentifierValidationProfile,
  IdentifierValidationResponse
} from 'models/product';

export type IdentifierValidationStatus = {
  hasInvalidPnc: boolean;
  hasInvalidHid: boolean;
  hasInvalidSerialNumber: boolean;
};

export function isProductRegistered(
  response: IdentifierValidationResponse
): boolean {
  for (const item of response.data) {
    const { registration } = item.attributes;
    if (registration?.status === 'REGISTERED') {
      return true;
    }
  }

  return false;
}

export function isProductIdentifierValid(
  response: IdentifierValidationResponse
): IdentifierValidationProfile[] | null {
  const invalidProfiles: IdentifierValidationProfile[] = [];

  for (const item of response.data) {
    const itemInvalidProfiles: IdentifierValidationProfile[] = [];

    for (const profile of item.attributes.profiles) {
      const isValidationValid = profile.validation?.status === 'VALID';

      // Check that the PNC profile has successful verification
      // If successful verification, then the product exists in DIMR
      const hasVerificationFailure =
        profile.profile === 'PNC' &&
        (profile.verification?.some(
          (verification) => verification.status === 'FAILED'
        ) ??
          false);

      const isProfileValid = isValidationValid && !hasVerificationFailure;
      if (!isProfileValid) {
        itemInvalidProfiles.push(profile);
      }
    }

    if (itemInvalidProfiles.length === 0) {
      return null;
    }

    invalidProfiles.push(...itemInvalidProfiles);
  }

  return invalidProfiles;
}

export function getIdentifierValidationStatus(
  profiles: IdentifierValidationProfile[]
): IdentifierValidationStatus {
  let hasInvalidPnc = false;
  let hasInvalidHid = false;
  let hasInvalidSerialNumber = false;

  for (const profile of profiles) {
    const isValidationValid = profile.validation?.status === 'VALID';
    // If PNC verification is successful, then the product exists in DIMR
    const hasVerificationFailure =
      profile.profile === 'PNC' &&
      (profile.verification?.some(
        (verification) => verification.status === 'FAILED'
      ) ??
        false);

    const isInvalidProfile = !isValidationValid || hasVerificationFailure;
    if (!isInvalidProfile) {
      continue;
    }

    const isInvalidStatus = profile.validation?.status === 'INVALID';

    if (
      profile.profile === 'PNC' &&
      (isInvalidStatus || hasVerificationFailure)
    ) {
      hasInvalidPnc = true;
      continue;
    }

    if (profile.profile === 'HID' && isInvalidStatus) {
      hasInvalidHid = true;
      continue;
    }

    if (profile.profile.includes('SN') && isInvalidStatus) {
      hasInvalidSerialNumber = true;
    }
  }

  return {
    hasInvalidPnc,
    hasInvalidHid,
    hasInvalidSerialNumber
  };
}
